import "core-js/modules/es.array.concat.js";
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { EditOutlineIcon, ResetOutlineIcon } from '@applyboard/ui-icons';
import { Flex, Button } from '@applyboard/crystal-ui';
import { getApplication } from "../../../../../../store/Selectors";
import { initializeStore } from "../../../../../../store/Actions/Actions";
import { Routes } from "../../../Constants";
import { useAppContext, EligibilityResultsContext } from "../../../../Providers";
import { useCefEventTracker } from "../../../../Hooks/useCefEventTracker";
import useCefNavigation from "../../../../Hooks/useCefNavigation";
import { CefEvent, Platform, CefEventName } from "../../../../../../EventTracker";
import { studentOnboarding } from "../../../../../controller/consts";
var EditActions = function EditActions(props) {
  var _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var navigate = useCefNavigation();
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  var _useContext = useContext(EligibilityResultsContext),
    eligibilityResults = _useContext.eligibilityResults;
  var platform = isMobile ? Platform.Mobile : Platform.Desktop;
  var editEligibility = function editEligibility(clear) {
    var _eligibilityResults$r;
    if (clear) {
      props.initializeStore(undefined);
    }
    var route = Routes.Eligibility.NationalityQuestion;
    trackEvent(CefEvent(clear ? CefEventName.ClickedStartOver : CefEventName.ClickedEditEligibility, platform));
    var eventMessage = clear ? 'Start Over' : 'Edit Eligibility';
    if ((eligibilityResults === null || eligibilityResults === void 0 ? void 0 : (_eligibilityResults$r = eligibilityResults.result) === null || _eligibilityResults$r === void 0 ? void 0 : _eligibilityResults$r.eligibility) === 'ineligible') {
      trackEvent({
        event: "".concat(studentOnboarding, " - CEF - Not Eligible: Clicked ").concat(eventMessage),
        group: studentOnboarding
      });
    }
    navigate(route);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    direction: {
      xs: 'column',
      sm: 'row'
    },
    justify: {
      xs: 'start',
      sm: 'between'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return editEligibility(false);
    },
    leadIcon: EditOutlineIcon,
    emphasis: "transparent",
    intent: "primary"
  }, "Edit eligibility"), !userId && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return editEligibility(true);
    },
    leadIcon: ResetOutlineIcon,
    emphasis: "transparent",
    intent: "primary"
  }, "Start over"));
};
var mapStateToProps = function mapStateToProps(state) {
  var _application$national;
  var application = getApplication(state);
  return {
    isRPSelectorEnabledNationality: ((_application$national = application.nationality) === null || _application$national === void 0 ? void 0 : _application$national.code) === 'PH'
  };
};
var connector = connect(mapStateToProps, {
  initializeStore: initializeStore
});
export default connector(EditActions);